"use strict";
const coupons = document.querySelector(".coupons");
if (coupons) {
    const couponItems = coupons.querySelectorAll(".coupon-item");
    couponItems.forEach((couponItem) => {
        const form = couponItem?.querySelector("form");
        form?.addEventListener("submit", (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            fetch(`${form?.action}`, { method: "POST", body: formData })
                .then((response) => response.json())
                .then((data) => {
                const scratch = couponItem?.querySelector(".coupon-item-scratch");
                const content = document.createElement("div");
                content.classList.add("coupon-item-content");
                if (data.premiado) {
                    couponItem?.classList.add("awarded");
                    content.innerHTML =
                        `
              <span class="s2-subtitle">Você ganhou um(a) <span class="highlight-text">${data.premio}</span> Parabéns! 🎉🎉</span>
              <span class="supply c4-caption">Abastecimento: ${data.abastecimento}</span>
              `;
                }
                else {
                    content.innerHTML =
                        `
                <span class="s2-subtitle">Ainda não foi dessa vez!</span>
                <span class="c4-caption">Lembre-se: a cada R$ 100 em Shell V-Power Etanol, <span class="highlight-text">pagando com Shell Box</span>, você ganha uma nova chance de mudar sua sorte. Abasteça!</span>
                <span class="supply c4-caption">Abastecimento: ${data.abastecimento}</span>
              `;
                }
                scratch.insertAdjacentElement("beforebegin", content);
                setTimeout(() => {
                    const overlay = couponItem?.querySelector(".coupon-item-scratch-overlay");
                    const frames = overlay?.querySelectorAll(".scratch-frame");
                    scratch.remove();
                    for (let i = 0; i < frames.length; i++) {
                        setTimeout(() => {
                            frames[i].classList.remove("active");
                            if (i >= frames.length - 1) {
                                overlay.remove();
                                if (data.premiado) {
                                    const modal = document.createElement("div");
                                    modal?.classList.add("awarded-modal");
                                    modal.innerHTML =
                                        `
                      <div class="awarded-modal-content">
                        <span class="h2-mobile">Parabéns, você acabou de raspar um prêmio instantâneo!</span>
                        <span class="p2-paragraph highlight-text">Recarregando em: <span class="timer">3</span> </span>
                      </div>
                    `;
                                    setTimeout(() => {
                                        document.body.appendChild(modal);
                                        setTimeout(() => {
                                            modal.querySelector(".awarded-modal-content")?.classList.add("active");
                                            const timer = modal.querySelector('.timer');
                                            timer.innerHTML = 3;
                                            const interval = setInterval(() => {
                                                const newValue = parseInt(timer.innerHTML, 10) - 1;
                                                timer.innerHTML = newValue;
                                                if (newValue === 0) {
                                                    clearInterval(interval);
                                                    window.location.reload();
                                                }
                                            }, 1000);
                                        }, 100);
                                    }, 200);
                                }
                            }
                            else {
                                frames[i + 1].classList.add("active");
                            }
                        }, 150 * i);
                    }
                }, 50);
            })
                .catch((error) => console.log(error));
        });
    });
}
